import { render, staticRenderFns } from "./Echarts6.vue?vue&type=template&id=631b5c58&scoped=true&"
import script from "./Echarts6.vue?vue&type=script&lang=js&"
export * from "./Echarts6.vue?vue&type=script&lang=js&"
import style0 from "./Echarts6.vue?vue&type=style&index=0&id=631b5c58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b5c58",
  null
  
)

export default component.exports